<template>
  <div class="write-detail-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-btn" @click="goBack">
        <span class="back-icon">‹</span>
      </div>
      <div class="header-title">{{ title }}</div>

      <!-- <div class="record-btn" @click="goToRecord">生成记录</div> -->
    </div>

    <div class="content">
      <div class="content-title">{{ cardTitle }}</div>
      <div class="messages-container">
        <div v-for="(msg, index) in messages" :key="index" class="message-item">
          <div v-if="msg.role === 'user'" class="user-message">
            <div class="message-content user-content">{{ msg.content }}</div>
          </div>
          <div v-else class="assistant-message">
            <div
              class="message-content assistant-content"
              v-html="msg.content"
            ></div>
            <div style="display: flex;flex-wrap: nowrap;">
              <div class="copy-btn" @click="playResult">
                <img src="@/assets/video/yy.png" alt="" class="copy-img" />
                <span class="copy-icon">播放</span>
              </div>
              <div class="copy-btn" @click="copyContent(msg.content)">
                <img src="@/assets/video/fz.png" alt="" class="copy-img" />
                <span class="copy-icon">复制</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isGenerating" class="message-item assistant-message">
          <div
            v-if="showResult"
            class="message-content assistant-content"
            v-html="resultHtml"
          ></div>
          <div v-else class="result-placeholder">
            正在分析
            <div class="loading-wave">
              <div class="wave-item"></div>
              <div class="wave-item"></div>
              <div class="wave-item"></div>
              <div class="wave-item"></div>
              <div class="wave-item"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="input-section">
      <textarea
        class="input-textarea"
        v-model="inputText"
        placeholder="发送消息"
        maxlength="200"
        :disabled="isGenerating"
      ></textarea>
      <div class="input-actions">
        <div class="char-count">{{ inputText.length }}/200</div>
        <div class="send-btn" @click="sendMessage">发送</div>
      </div>
    </div>

    <!-- 底部按钮区域 - 确保始终显示 -->
  </div>
</template>

<script>
import { streamChats, voiceChatVoice } from "@/api/video";
import { marked } from "marked";
export default {
  data() {
    return {
      inputText: "",
      isGenerating: false,
      showResult: false,
      resultHtml: "",
      typingText: "",
      fullText: "正在分析...",
      typingIndex: 0,
      typingInterval: null,
      typingContentInterval: null,
      href: "",
      fullTypingContent: "",
      isTypingActive: false,
      contentLoadingComplete: false,
      currentDisplayIndex: 0,
      isPlayingVoice: false,
      currentAudioSource: null,
      currentAudioElement: null,
      title: "",
      cardTitle: "",
      source: "",
      messages: [],
      showGeneratingMessage: false,
    };
  },
  beforeDestroy() {
    this.resetGeneratingState();
    this.stopAudio();
  },
  watch: {
    // messages: {
    //   handler() {
    //     this.$nextTick(() => {
    //       this.scrollToBottom();
    //     });
    //   },
    //   deep: true,
    // },
    // resultHtml() {
    //   this.$nextTick(() => {
    //     this.scrollToBottom();
    //   });
    // },
  },

  mounted() {
    const query = this.$route.query;
    this.href = query.href || "";
    this.title = query.title || "";
    this.cardTitle = query.cardTitle || "";
    this.source = query.source || "";
    this.inputText = query.inputText || "";

    console.log("writeDetail.vue - 接收到的参数:", {
      href: this.href,
      title: this.title,
      cardTitle: this.cardTitle,
      source: this.source,
      inputText: this.inputText,
    });

    if (this.inputText) {
      const initialContent = this.inputText;
      this.messages.push({
        role: "user",
        content: initialContent,
      });
      this.generateContent(initialContent);
      this.inputText = "";
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },

    goToRecord() {
      console.log("跳转到生成记录");
    },

    copyContent(content) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = content;
      const text = tempDiv.textContent || tempDiv.innerText || "";

      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$notify({
            title: "提示",
            message: "复制成功",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        })
        .catch((err) => {
          console.error("复制失败:", err);
          this.$notify({
            title: "提示",
            message: "复制失败，请重试",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        });
    },

    sendMessage() {
      if (!this.inputText.trim()) {
        this.$notify({
          title: "提示",
          message: "请输入消息",
          position: "top-center",
          duration: 2000,
          showClose: false
        });
        return;
      }

      // 重置之前的生成状态
      this.resetForNewMessage();

      const messageContent = this.inputText;
      this.messages.push({
        role: "user",
        content: messageContent,
      });

      this.generateContent(messageContent);
      this.inputText = "";
    },

    async generateContent(content) {
      if (!content || !content.trim()) return;

      this.isGenerating = true;
      this.showResult = false;
      this.resultHtml = "";
      this.fullTypingContent = "";
      this.currentDisplayIndex = 0;
      this.isTypingActive = false;
      this.contentLoadingComplete = false;

      this.stopTypingAnimation();
      if (this.typingContentInterval) {
        clearInterval(this.typingContentInterval);
        this.typingContentInterval = null;
      }

      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error("请求超时，请检查网络连接")), 30000);
      });

      try {
        const response = await Promise.race([
          streamChats(this.href, content),
          timeoutPromise,
        ]);

        console.log('原始响应241:', response);

        if (!response.ok) {
          throw new Error(`请求失败: ${response.status}`);
        }

        // 检查响应的code字段
        const responseData = await response.clone().json().catch(() => null);

        console.log('解析后的JSON数据248:', responseData);
        if (responseData) {
          if (responseData.code === 401) {
            console.log('检测到code为401的错误:', responseData.msg);
            this.isGenerating = false;
            this.showResult = false;
            this.$notify({
              title: "提示",
              message: responseData.msg || '未登录，请重新登录',
              position: "top-center",
              duration: 2000,
              showClose: false
            });
            setTimeout(() => {
              window.location.href = '/login';
            }, 2000);
            return;
          }
          
          if (responseData.code === 600) {
            console.log('检测到code为600的错误:', responseData.msg);
            this.isGenerating = false;
            this.showResult = false;
            this.$notify({
              title: "提示",
              message: responseData.msg || '权限不足，请开通会员',
              position: "top-center",
              duration: 2000,
              showClose: false
            });
            setTimeout(() => {
              window.location.href = '/vip';
            }, 2000);
            return;
          }
          
          if (responseData.code === 500) {
            console.log('检测到code为500的错误:', responseData.msg);
            this.isGenerating = false;
            this.showResult = false;
            this.$notify({
              title: "提示",
              message: responseData.msg || '请求失败，请稍后重试',
              position: "top-center",
              duration: 2000,
              showClose: false
            });
            return;
          }
        }

        // 检查response.body是否存在
        if (!response.body) {
          throw new Error("响应流不存在");
        }

        // 获取响应流
        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        // 停止思考中动画，准备接收实际内容
        this.stopTypingAnimation();

        // 实时接收并显示流式响应内容
        let fullContent = "";

        // 确保在接收内容前显示结果区域
        this.showResult = true;

        // 最多读取次数限制，防止无限循环
        let readCount = 0;
        const MAX_READ_COUNT = 1000;

        while (true) {
          readCount++;

          // 安全检查，防止无限循环
          if (readCount > MAX_READ_COUNT) {
            console.warn("已达到最大读取次数，强制结束流读取");
            // 标记内容已完成，但保留isGenerating状态直到打字机完成
            this.contentLoadingComplete = true;
            this.updateTypingContent(fullContent);
            break;
          }

          try {
            const { done, value } = await reader.read();

            // 关键：当done为true时不立即重置isGenerating状态
            if (done) {
              console.log("流读取完成",done,value);
              // 标记内容已完成，但保留isGenerating状态直到打字机完成
              this.contentLoadingComplete = true;
              break;
            }

            // 解码接收到的数据块
            let chunk = decoder.decode(value, { stream: true });

            // 移除data前缀（增强处理，移除所有出现的data前缀，不仅限于行首）
            chunk = chunk.replace(/data:/g, "");

            // 检查是否包含[invalid vip]标记
            if (chunk.includes('[invalid vip]')) {
              console.log('检测到[invalid vip]标记');
              this.contentLoadingComplete = true;
              this.resultHtml = `<div style="color: #ef4444; padding: 20px; font-size: 15px;">请开通会员</div>`;
              this.showResult = true;
              this.isGenerating = false;
              this.stopTypingAnimation();
              if (this.typingContentInterval) {
                clearInterval(this.typingContentInterval);
                this.typingContentInterval = null;
              }
              break;
            }

            // 检查是否包含[DONE]标记
            if (chunk.includes('[DONE]')) {
              // 移除[DONE]标记
              chunk = chunk.replace('[DONE]', '');
              // 标记内容已完成
              this.contentLoadingComplete = true;
            }

            // 追加到完整内容
            fullContent += chunk;

            // 更新完整内容并触发打字机效果（不等待）
            this.updateTypingContent(fullContent);

            // 如果已完成，停止读取
            if (this.contentLoadingComplete) {
              break;
            }
          } catch (streamError) {
            console.error("读取流数据失败:", streamError);
            // 即使发生流错误，也要确保状态正确重置
            this.contentLoadingComplete = true;
            this.updateTypingContent(fullContent);
            break;
          }
        }
      } catch (error) {
        console.error("生成内容失败:", error);
        // 确保在任何错误情况下都重置状态
        this.isGenerating = false;
        this.stopTypingAnimation();

        // 显示错误信息
        this.resultHtml = `
          <div style="color: #ef4444; padding: 20rpx;">
            <p>生成失败，请稍后重试</p>
            <p style="font-size: 24rpx; margin-top: 10rpx;">错误信息: ${error.message}</p>
          </div>
        `;
        this.showResult = true;
      }
    },

    // 当用户发送新消息时，重置生成状态
    resetForNewMessage() {
      this.isGenerating = false;
      this.showResult = false;
      this.resultHtml = "";
      this.fullTypingContent = "";
      this.currentDisplayIndex = 0;
      this.isTypingActive = false;
      this.contentLoadingComplete = false;
      this.stopTypingAnimation();
      if (this.typingContentInterval) {
        clearInterval(this.typingContentInterval);
        this.typingContentInterval = null;
      }
    },

    // 重置所有生成相关状态和定时器
    resetGeneratingState() {
      // 确保重置isGenerating状态
      this.isGenerating = false;

      // 重置内容加载完成标记
      this.contentLoadingComplete = false;

      // 重置显示索引
      this.currentDisplayIndex = 0;

      // 清理思考中动画定时器
      if (this.typingInterval) {
        clearInterval(this.typingInterval);
        this.typingInterval = null;
      }

      // 清理打字机效果定时器
      if (this.typingContentInterval) {
        clearInterval(this.typingContentInterval);
        this.typingContentInterval = null;
      }
    },

    // 更新打字机内容（并行流式渲染）
    updateTypingContent(content) {
      // 存储最新的完整内容
      this.fullTypingContent = content;

      // 确保在更新内容时显示结果
      this.showResult = true;

      // 启动或更新打字机效果
      if (!this.isTypingActive) {
        this.isTypingActive = true;
        this.startTypingAnimationForContent();
      }
    },

    // 为内容启动打字机效果
    startTypingAnimationForContent() {
      // 清除可能存在的定时器
      if (this.typingContentInterval) {
        clearInterval(this.typingContentInterval);
        this.typingContentInterval = null;
      }

      // 当前已显示的文本长度 - 使用实例变量存储，确保新数据到达时保持连续性
      this.currentDisplayIndex = this.currentDisplayIndex || 0;

      // 启动新的定时器
      this.typingContentInterval = setInterval(() => {
        // 确保fullTypingContent存在
        if (!this.fullTypingContent) {
          return;
        }

        // 如果还有内容未显示
        if (this.currentDisplayIndex < this.fullTypingContent.length) {
          // 逐字符连续显示，确保整体内容流畅不间断
          this.currentDisplayIndex += 1; // 每次只显示一个字符

          // 直接获取当前应该显示的文本内容，不进行换行处理
          const displayContent = this.fullTypingContent.substring(
            0,
            this.currentDisplayIndex
          );

          // 将markdown转换为HTML
          const markdownHtml = this.markdownToHtml(displayContent);

          // 直接设置内容，确保连续显示，不进行任何换行处理
          this.resultHtml = `<div style="color: #a0aec0; line-height: 1.6; word-wrap: break-word; word-break: break-all; white-space: normal;">${markdownHtml}</div>`;

          // 确保在打字机过程中显示结果
          this.showResult = true;
        } else {
          // 所有内容都已显示完成
          if (this.contentLoadingComplete) {
            // 先清除定时器
            clearInterval(this.typingContentInterval);
            this.typingContentInterval = null;
            this.isTypingActive = false;

            // 将完整的markdown内容转换为HTML
            const finalHtml = this.markdownToHtml(this.fullTypingContent);

            // 先添加消息到数组
            this.messages.push({
              role: "assistant",
              content: finalHtml,
            });

            // 最后设置isGenerating为false
            this.isGenerating = false;
          }
        }
      }, 20); // 保持较快的显示速度，确保文本连续流畅
    },

    // 开始打字机效果
    startTypingAnimation() {
      this.typingText = "";
      this.typingIndex = 0;

      // 清除之前的定时器
      if (this.typingInterval) {
        clearInterval(this.typingInterval);
      }

      // 设置新的定时器
      this.typingInterval = setInterval(() => {
        if (this.typingIndex < this.fullText.length) {
          this.typingText += this.fullText.charAt(this.typingIndex);
          this.typingIndex++;
        } else {
          // 打字完成后，重置以形成循环效果
          this.typingIndex = 0;
          this.typingText = "";
        }
      }, 200);
    },

    // 停止打字机效果
    stopTypingAnimation() {
      if (this.typingInterval) {
        clearInterval(this.typingInterval);
        this.typingInterval = null;
      }
    },
    // 播放结果
    playResult() {
      // 获取纯文本内容，去掉div标签
      const plainText = this.getPlainTextFromHtml(this.resultHtml);
      console.log("播放结果", plainText);
      this.handleVoice(plainText);
      // 实际项目中这里应该调用语音播放API，使用plainText而不是带标签的HTML
    },

    async handleVoice(text) {
      // 检查是否正在播放语音
      if (this.isPlayingVoice) {
        this.$notify({
          title: "提示",
          message: "语音正在播放中，请等待播放完成后再点击",
          position: "top-center",
          duration: 2000,
          showClose: false
        });
        return;
      }

      try {
        // 设置播放状态为正在播放
        this.isPlayingVoice = true;

        // 显示加载状态
        this.$notify({
          title: "提示",
          message: "加载语音中",
          position: "top-center",
          duration: 2000,
          showClose: false
        });

        // 调用语音播报接口
        const response = await voiceChatVoice({ text });

        console.log("语音接口响应:", response);

        // 打印完整的响应对象，以便调试
        console.log("完整语音接口响应:", JSON.stringify(response, null, 2));

        // 检查响应中是否存在audio数组
        if (!response || !response.data.audio || !Array.isArray(response.data.audio)) {
          console.error("未找到有效的音频数据479:", response.data);
          this.$notify({
            title: "提示",
            message: "未获取到有效的音频数据",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
          this.isPlayingVoice = false;
          return;
        }

        const byteArray = response.data.audio;
        // 将字节数组转换为16位PCM样本
        const samples = new Int16Array(byteArray.length / 2);
        for (let i = 0; i < samples.length; i++) {
          let byte1 = byteArray[i * 2];
          let byte2 = byteArray[i * 2 + 1];
          // 将可能为负的字节值转换为0-255范围
          if (byte1 < 0) byte1 += 256;
          if (byte2 < 0) byte2 += 256;

          // 合成16位有符号整数
          let intVal = (byte2 << 8) | byte1;
          // 手动处理符号位
          if (intVal >= 32768) {
            intVal -= 65536;
          }
          samples[i] = intVal;
        }

        // 将16位PCM样本归一化为-1.0到1.0之间的32位浮点数
        const float32Array = new Float32Array(samples.length);
        for (let i = 0; i < samples.length; i++) {
          float32Array[i] = samples[i] / 32768.0;
        }

        console.log("音频数组长度:", float32Array.length);

        // 获取采样率，如果接口没有返回，则使用默认值
        const sampleRate = response.sample_rate || 16000;
        console.log("音频采样率:", sampleRate);

        // 创建音频上下文
        const audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();

        try {
          // 1. 主要方案：使用处理好的 float32Array
          const audioBuffer = audioContext.createBuffer(
            1,
            float32Array.length,
            sampleRate
          );

          // 将数据复制到缓冲区的第一个通道
          audioBuffer.getChannelData(0).set(float32Array);

          // 创建音频源节点
          const source = audioContext.createBufferSource();
          source.buffer = audioBuffer;
          source.connect(audioContext.destination);

          // 保存音频源引用，以便在需要时停止播放
          this.currentAudioSource = source;

          // 设置播放结束事件处理
          const onEndedHandler = () => {
            this.$notify({
              title: "提示",
              message: "语音播放完成",
              position: "top-center",
              duration: 2000,
              showClose: false
            });
            this.isPlayingVoice = false;
            this.currentAudioSource = null;
            source.removeEventListener("ended", onEndedHandler);
          };

          source.addEventListener("ended", onEndedHandler);
          source.start();

          this.$notify({
            title: "提示",
            message: "播放中",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        } catch (audioError) {
          console.error("音频处理错误:", audioError);
          this.$notify({
            title: "提示",
            message: "音频处理失败，请重试",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
          this.isPlayingVoice = false;
          this.currentAudioSource = null;

          // 2. 后备方案：尝试将数组转换为WAV格式并直接播放
          try {
            console.log("尝试使用后备方案播放...");
            this.playAudioArrayAsWav(float32Array, sampleRate);
          } catch (fallbackError) {
            console.error("后备播放方式也失败:", fallbackError);
            this.isPlayingVoice = false; // 重置播放状态
            this.currentAudioSource = null;
          }
        }
      } catch (error) {
        console.error("语音请求错误:", error);
        this.isPlayingVoice = false; // 重置播放状态
        this.currentAudioSource = null;

        // 错误类型处理
        if (error.code === "ECONNABORTED") {
          this.$notify({
            title: "提示",
            message: "语音生成超时，请稍后重试",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        } else if (error.message && error.message.includes("Network Error")) {
          this.$notify({
            title: "提示",
            message: "网络连接异常，请检查网络后重试",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        } else {
          this.$notify({
            title: "提示",
            message: "语音生成失败，请重试",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        }
      }
    },

    // 辅助方法：将音频数组转换为WAV格式并播放
    playAudioArrayAsWav(floatArray, sampleRate = 16000) {
      try {
        // 假设音频数据已经是归一化后的Float32Array
        // 创建WAV文件头
        const buffer = new ArrayBuffer(44 + floatArray.length * 2);
        const view = new DataView(buffer);

        // 写入WAV文件头信息
        this.writeWavHeader(view, floatArray.length, sampleRate);

        // 写入音频数据（转换为16位整数）
        for (let i = 0; i < floatArray.length; i++) {
          // 将[-1,1]范围的浮点数转换为[-32768, 32767]范围的整数
          const intValue = Math.max(
            -32768,
            Math.min(32767, Math.floor(floatArray[i] * 32767))
          );
          view.setInt16(44 + i * 2, intValue, true);
        }

        // 创建Blob并播放
        const blob = new Blob([view], { type: "audio/wav" });
        const audioUrl = URL.createObjectURL(blob);
        const audio = new Audio(audioUrl);

        // 保存音频元素引用
        this.currentAudioElement = audio;

        audio
          .play()
          .then(() => {
            this.$notify({
              title: "提示",
              message: "尝试使用后备方式播放音频",
              position: "top-center",
              duration: 2000,
              showClose: false
            });
          })
          .catch((playError) => {
            console.error("后备播放失败:", playError);
            this.$notify({
              title: "提示",
              message: "后备播放方式也失败",
              position: "top-center",
              duration: 2000,
              showClose: false
            });
            this.isPlayingVoice = false;
            this.currentAudioElement = null;
          });

        // 播放结束后释放URL
        const onEndedHandler = () => {
          URL.revokeObjectURL(audioUrl);
          this.isPlayingVoice = false; // 重置播放状态
          this.currentAudioElement = null;
          audio.removeEventListener("ended", onEndedHandler);
        };

        audio.addEventListener("ended", onEndedHandler);
      } catch (error) {
        console.error("WAV转换失败:", error);
        this.isPlayingVoice = false; // 重置播放状态
        this.currentAudioElement = null;
        throw error;
      }
    },

    // 辅助方法：写入WAV文件头
    writeWavHeader(view, length, sampleRate) {
      // RIFF chunk descriptor
      this.writeString(view, 0, "RIFF");
      view.setUint32(4, 36 + length * 2, true);
      this.writeString(view, 8, "WAVE");
      // FMT sub-chunk
      this.writeString(view, 12, "fmt ");
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, 1, true); // 单声道
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, sampleRate * 2, true); // 字节率 = 采样率 * 通道数 * 采样位数/8
      view.setUint16(32, 2, true); // 块对齐 = 通道数 * 采样位数/8
      view.setUint16(34, 16, true); // 采样位数
      // Data sub-chunk
      this.writeString(view, 36, "data");
      view.setUint32(40, length * 2, true);
    },

    // 辅助方法：写入字符串到DataView
    writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    },

    // 复制结果
    copyResult() {
      const text = this.getPlainTextFromHtml(this.resultHtml);
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$notify({
            title: "提示",
            message: "复制成功",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "复制失败",
            position: "top-center",
            duration: 2000,
            showClose: false
          });
        });
    },

    // 删除结果
    clearResult() {
      this.showResult = false;
      this.resultHtml = "";
    },

    // 从HTML中提取纯文本
    getPlainTextFromHtml(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      let text = tempDiv.textContent || tempDiv.innerText || "";
      // 移除所有换行符
      return text.replace(/\n/g, "");
    },

    // 格式化内容为HTML
    formatContentToHtml(content) {
      if (!content || content.trim() === "") {
        return '<div style="color: #000; line-height: 1.6; word-wrap: break-word; word-break: break-all; white-space: normal;"></div>';
      }

      // 将markdown转换为HTML
      const markdownHtml = marked.parse(content);

      // 返回带样式的div容器，使用normal以确保文本流畅显示
      return `<div style="color: #000; line-height: 1.6; word-wrap: break-word; word-break: break-all; white-space: normal;">${markdownHtml}</div>`;
    },

    // Markdown转HTML
    markdownToHtml(markdown) {
      if (!markdown || markdown.trim() === "") {
        return "";
      }
      // 移除[DONE]标记
      const cleanedMarkdown = markdown.replace('[DONE]', '');
      return marked.parse(cleanedMarkdown);
    },
  },
};
</script>

<style scoped>
.write-detail-page {
  color: #fff;
  padding: 5px 0px 10px 0px;
  background-image: url("../../assets/video/bg.png");
  height: 100vh;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 15px 10px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  /* background-color: #000; */
  z-index: 100;
}

.back-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  font-size: 24px;
  color: #000;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  position: fixed;
  left: 50%;
  top: 40px;
  transform: translate(-50%, -50%);
}

.record-btn {
  font-size: 14px;
  color: #a0aec0;
}

.content {
  flex: 1;
  padding: 70px 15px 10px;
  overflow-y: auto;
  padding-bottom: 100px;
}

.content-title {
  font-size: 24px;
  font-weight: 600;
  color: #072b60;
  line-height: 66rpx;
  text-align: center;
  font-style: normal;
  margin-right: 20px;
}

.messages-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.message-item {
  /* justify-content: flex-end; */
}

.user-message {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}

.assistant-message {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}

.copy-btn {
  margin-top: 8px;
  padding: 6px 12px;
  background: #f5f5f5;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s;
  align-self: flex-start;
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-right: 10px;
}
.copy-img {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}
.copy-btn:hover {
  background: #e8e8e8;
}

.copy-btn:active {
  opacity: 0.7;
}

.copy-icon {
  font-size: 12px;
  color: #666;
}

.message-content {
  /* max-width: 75%; */
  padding: 12px 16px;
  border-radius: 16px;
  font-size: 15px;
  line-height: 1.5;
  /* word-wrap: break-word;
  word-break: break-all; */
  text-align: left;
}

.user-content {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-radius: 16px 16px 4px 16px;
}

.assistant-content {
  background: #ffffff;
  color: #333;
  border-radius: 16px 16px 16px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Markdown样式 */
.assistant-content h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
  color: #072b60;
}

.assistant-content h2 {
  font-size: 18px;
  font-weight: bold;
  margin: 8px 0;
  color: #072b60;
}

.assistant-content h3 {
  font-size: 16px;
  font-weight: bold;
  margin: 6px 0;
  color: #072b60;
}

.assistant-content p {
  margin: 5px 0;
  line-height: 1.6;
}

.assistant-content ul,
.assistant-content ol {
  margin: 5px 0;
  padding-left: 20px;
}

.assistant-content li {
  margin: 3px 0;
}

.assistant-content code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: #e83e8c;
}

.assistant-content pre {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 10px 0;
}

.assistant-content pre code {
  background: transparent;
  padding: 0;
  color: #333;
}

.assistant-content blockquote {
  border-left: 4px solid #667eea;
  padding-left: 10px;
  margin: 10px 0;
  color: #666;
  font-style: italic;
}

.assistant-content a {
  color: #667eea;
  text-decoration: underline;
}

.assistant-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.assistant-content th,
.assistant-content td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.assistant-content th {
  background: #f5f5f5;
  font-weight: bold;
}

.assistant-content hr {
  border: none;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

.assistant-content strong {
  font-weight: bold;
}

.assistant-content em {
  font-style: italic;
}

.input-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 15px;
  background: #ffffff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-end;
  gap: 10px;
  z-index: 100;
}

.input-textarea {
  flex: 1;
  min-height: 40px;
  max-height: 120px;
  background: #f5f5f5;
  border: none;
  border-radius: 20px;
  padding: 12px 16px;
  color: #333;
  font-size: 15px;
  line-height: 1.5;
  box-sizing: border-box;
  resize: none;
}

.input-textarea::placeholder {
  color: #999;
}

.input-textarea:disabled {
  opacity: 0.6;
}

.input-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.char-count {
  font-size: 12px;
  color: #999;
}

.send-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 10px 24px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.send-btn:active {
  opacity: 0.8;
}

.loading-section {
  margin-top: 15px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding: 8px 12px;
  background: #ffffff;
  border-radius: 16px 16px 16px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 75%;
}

.loading-indicator.completed {
  margin-top: 15px;
}

.ai-ultra-text {
  font-size: 14px;
  color: #667eea;
  margin-right: 5px;
  font-weight: 500;
}

.thinking-text {
  font-size: 14px;
  color: #667eea;
  font-weight: 500;
}

.typing-animation::after {
  content: "|";
  animation: blink 1s infinite;
  margin-left: 2px;
  color: #667eea;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.result-placeholder {
  background-color: #ffffff;
  border-radius: 16px 16px 16px 4px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #000;
}

/* 波浪加载动画 */
.loading-wave {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.wave-item {
  width: 6px;
  height: 20px;
  background-color: #667eea;
  margin: 0 4px;
  border-radius: 3px;
  animation: wave 1.2s infinite ease-in-out;
}

.wave-item:nth-child(2) {
  animation-delay: 0.1s;
}
.wave-item:nth-child(3) {
  animation-delay: 0.2s;
}
.wave-item:nth-child(4) {
  animation-delay: 0.3s;
}
.wave-item:nth-child(5) {
  animation-delay: 0.4s;
}

@keyframes wave {
  0%,
  40%,
  100% {
    height: 20px;
    opacity: 0.6;
  }
  20% {
    height: 40px;
    opacity: 1;
  }
}
</style>
